import { render, staticRenderFns } from "./Licenses.vue?vue&type=template&id=406cbeb1"
import script from "../services/Licenses.js?vue&type=script&lang=js&external"
export * from "../services/Licenses.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports